import React, { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { AppContext } from '@prisjakt/ui-app-context';
import { Panel, PanelHeader, PanelTitle } from '@prisjakt/ui/panel';
import { ExpandableGrid } from 'src/components/expandable-grid';
import { ProductGridCard } from 'src/components/product-card-new';
import { Column } from '@prisjakt/ui/list/variants';
import { productNavigation } from '../../areas/product/actions/product';
import { NEW_PRODUCT_CLICK } from '../../globals/helpers/navigation-action';
import { filterCategories } from '../../areas/landing-page/components/product-recommendations/filter-categories';
import { NewProductRecommendationsFragment, Product, Maybe } from 'src/types';
import { useViewportContext } from 'src/components/viewport/context';

type Props = {
  newReleases?: Recommendations['newReleases'];
};

type Recommendations = NonNullable<
  NewProductRecommendationsFragment['newProductRecommendations']
>;

const NewProductReleases: React.FC<Props> = props => {
  const { newReleases: newProducts = { nodes: [] } } = props;
  const { isTablet } = useViewportContext();
  const dispatch = useDispatch();
  const { t } = useContext(AppContext);

  if (!(newProducts && newProducts.nodes) || newProducts.nodes.length === 0) {
    return null;
  }

  const newProductsItems = filterCategories(
    newProducts.nodes as Maybe<Product>[]
  );

  const newProductsCards = newProductsItems.map((product, index) => (
    <ProductGridCard
      key={product.id}
      brand={
        product.brand && {
          logo: product.brand.logo,
          name: product.brand.name,
        }
      }
      category={
        product.category && {
          name: product.category.name,
        }
      }
      imageSrc={product.media.first}
      shouldLazyLoadImage
      link={product.pathName}
      name={product.name}
      price={product.priceSummary.regular || product.priceSummary.alternative}
      onClick={() => {
        dispatch(productNavigation(NEW_PRODUCT_CLICK, index + 1));
      }}
    />
  ));

  return (
    <div>
      {newProductsItems.length > 0 && (
        <Panel>
          <PanelHeader>
            <Column style={{ flex: '0 1 auto' }}>
              <PanelTitle>
                {t('landing', 'personalized-releases.title')}
              </PanelTitle>
            </Column>
          </PanelHeader>

          <div>
            <ExpandableGrid
              limit={isTablet ? 3 : 4}
              expandText={t('common', 'button.show-more')}
              collapseText={t('common', 'button.show-less')}
              items={newProductsCards}
              cssGrid
            />
          </div>
        </Panel>
      )}
    </div>
  );
};

export default NewProductReleases;
